import { PlatformRequirementIssueStatus } from '@client/graphql/__generated__/types';

const platformRequirementIssueStatusLabels: Record<
  PlatformRequirementIssueStatus,
  string
> = {
  [PlatformRequirementIssueStatus.OPEN]: 'Current issue',
  [PlatformRequirementIssueStatus.IGNORED_BY_AGENT]: 'Ignored by agent',
  [PlatformRequirementIssueStatus.IGNORED_BY_REVIEWER]: 'Ignored by reviewer',
  [PlatformRequirementIssueStatus.RESUBMITTED]: 'Resubmitted',
};

/**
 * Returns the user-facing lifecycle label for a checklist issue.
 *
 * Lives in a leaf module rather than `platformRequirementIssues.utils` because
 * that module imports view-model types from `ChecklistIssuesList`, which now
 * renders these labels — importing the formatter back from there would close an
 * import cycle.
 */
export const formatPlatformRequirementIssueStatus = (
  status: PlatformRequirementIssueStatus
): string => platformRequirementIssueStatusLabels[status];
